import React from 'react';
import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './PageBanner.module.scss';

const PageBanner = ({ type = 'info', icon, iconColor = 'blue', className, children }) => {
  return (
    <div className={cx(classes.pageBanner, classes[type], className)}>
      {icon && <FontAwesomeIcon icon={icon} className={cx(classes.pageBannerIcon, classes[iconColor])} />}
      <div className={classes.pageBannerContent}>{children}</div>
    </div>
  );
};

export default PageBanner;
